module.exports = "<app-menu></app-menu>\r\n<router-outlet></router-outlet>"